import _get from 'lodash/get';

interface LubricantGroupListItem {
  id: string | number;
  groupName: string;
  remarks: string;
}

interface ApiResponse {
  success: boolean;
  message: string;
  data: {
    content: Array<{
      id: number;
      name: string;
      remark: string;
    }>;
  };
  timestamp: string;
  errors: any;
  requestId: string;
}

interface LubricantGroupsApiParser {
  LubricantGroupsListParser: (_res: ApiResponse) => LubricantGroupListItem[];
}

const lubricantGroupsApiParser: LubricantGroupsApiParser = {
  LubricantGroupsListParser: (_res: ApiResponse): LubricantGroupListItem[] => {
    // Parse the API response data
    const content = _get(_res, 'data.content', []);

    // Map API response to expected format
    const data: LubricantGroupListItem[] = content.map((item) => ({
      id: _get(item, 'id', 0),
      groupName: _get(item, 'name', ''),
      remarks: _get(item, 'remark', ''),
    }));

    return data;
  },
};

export default lubricantGroupsApiParser;

// --------------- Group-specific types and data ---------------

export interface LubricantGroupItem {
  id: number;
  groupName: string;
  remarks: string;
}

export interface LubricantGroupsData {
  groups: LubricantGroupItem[];
}
